var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "y-pd-20" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.canJoinKList },
        },
        [
          _c("el-table-column", {
            attrs: { label: "客户编码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.customerCode) +
                        "-" +
                        _vm._s(scope.row.customerName) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "合作网点", prop: "branchName" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.clickHasConnected(scope.row)
                          },
                        },
                      },
                      [_vm._v("已关联店铺")]
                    ),
                    scope.row.bindSellerStatus === "1"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.connectNewShopDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("新增关联店铺")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "empty" },
              slot: "empty",
            },
            [
              _vm._v(
                " " + _vm._s(_vm.loading ? "正在查询..." : "暂无数据") + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("hasConnectedShop", {
        attrs: {
          curCustomCode: _vm.curCustomCode,
          curCustomName: _vm.curCustomName,
          showConnectedDialog: _vm.showConnectedDialog,
        },
        on: {
          "update:showConnectedDialog": function ($event) {
            _vm.showConnectedDialog = $event
          },
          "update:show-connected-dialog": function ($event) {
            _vm.showConnectedDialog = $event
          },
        },
      }),
      _c("addConnectShop", {
        attrs: {
          curCustomCode: _vm.curCustomCode,
          curCustomName: _vm.curCustomName,
          showNewConnectDialog: _vm.showNewConnectDialog,
        },
        on: {
          "update:showNewConnectDialog": function ($event) {
            _vm.showNewConnectDialog = $event
          },
          "update:show-new-connect-dialog": function ($event) {
            _vm.showNewConnectDialog = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }